import { gql } from 'apollo-angular';

const UPDATE_PRODUCT_FORMULARY_PRICE = gql`
  mutation UpdateProductFormularyPrice(
    $rfpId: Long!
    $formularyPrices: [FormularyPrice!]!
  ) {
    updateProductFormularyPrice(
      updateProductFormularyPriceRequest: {
        rfpId: $rfpId
        prices: $formularyPrices
      }
    ) {
      id
    }
  }
`;

export default UPDATE_PRODUCT_FORMULARY_PRICE;
